import {
  gql,
  LazyQueryHookOptions,
  QueryHookOptions,
  TypedDocumentNode,
  useLazyQuery,
} from "@apollo/client";

import {
  GetRulesQuery,
  GetRulesQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { useFetchQuery } from "src/graphql/utils";
import { mapToRule } from "src/mappers/rule.mappers";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const getRulesQuery = gql(/* GraphQL */ `
  query getRules($caseTypeCode: String) {
    rules(caseTypeCode: $caseTypeCode) {
      id
      name
      description
      implementationType
      businessType
      code
    }
  }
`) as TypedDocumentNode<GetRulesQuery, GetRulesQueryVariables>;

export const useGetRulesQuery = (
  options?: QueryHookOptions<GetRulesQuery, GetRulesQueryVariables>
) => {
  return useFetchQuery(getRulesQuery, {
    queryOptions: options,

    isEmpty: (data) => isEmpty(data?.rules),
    toData: (data) => data?.rules?.map(mapToRule) ?? [],
    uiErrors: {
      fetchError: "FETCH-PERMISSIONS-ERROR",
    },
  });
};

export const useLazyGetRulesQuery = (
  options?: LazyQueryHookOptions<GetRulesQuery, GetRulesQueryVariables>
) => {
  return useLazyQuery(getRulesQuery, options);
};
